import React from "react";
import Otp from "../views/Otp";

const OtpPage = () => {
  return (
    <div className="h-screen h-full">
      <Otp />
    </div>
  );
};

export default OtpPage;
